(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-work-flow-type-attribute', {
            parent: 'entity',
            url: '/custom-work-flow-type-attribute?page&sort&search',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                pageTitle: 'trakeyeApp.customWorkFlowTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attributes.html',
                    controller: 'CustomWorkFlowTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-work-flow-type-attribute-detail', {
            parent: 'custom-work-flow-type-attribute',
            url: '/custom-work-flow-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"],
                pageTitle: 'trakeyeApp.customWorkFlowTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-detail.html',
                    controller: 'CustomWorkFlowTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomWorkFlowTypeAttribute', function($stateParams, CustomWorkFlowTypeAttribute) {
                    return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-work-flow-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

        .state('custom-work-flow-type-attribute.new', {
            parent: 'custom-work-flow-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
            }
        })
        .state('custom-work-flow-type-attribute.edit', {
            parent: 'custom-work-flow-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customWorkFlowTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomWorkFlowTypeAttribute', function($stateParams, CustomWorkFlowTypeAttribute) {
                    return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-work-flow-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-work-flow-type-attribute.delete', {
            parent: 'custom-work-flow-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER',"ROLE_PLAN_ADMIN","ROLE_ROLLOUT_ADMIN"]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-work-flow-type-attribute/custom-work-flow-type-attribute-delete-dialog.html',
                    controller: 'CustomWorkFlowTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomWorkFlowTypeAttribute', function(CustomWorkFlowTypeAttribute) {
                            return CustomWorkFlowTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-work-flow-type-attribute', null, { reload: 'custom-work-flow-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
